/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface PaymentConfigViewModel {
  datasetId?: string;
  imaginePayDataset?: string | null;
  clientId?: string | null;
  password?: string | null;
  paymentCodeId?: string;
  onlineProviderId?: string | null;
  datasetAcronym?: string | null;
}
